import currency from 'currency.js'
import toFinite from 'lodash/toFinite'
import reduce from 'lodash/reduce'

/* see https://currency.js.org/
 * R will create a  rand object based on the randOptions.
 * - R(value) will instantiate a currency object.
 * - R(value).value will return the numerical value of the
 *   currency object.
 * - R(value).format() will return a display format string for
 *   the currency object
 * Example:
 *  - R("20 000").value #=> 20000
 *  - R(50000).format() #=> "R 50 000"
 *
 *  @param { number } value - value of the currency
 *  @return { Object } - currency object
 */
export const R = (value, options = {}) => {
  const currencyOptions = { ...randOptions, ...options }
  if (typeof (value) === 'string') {
    return currency(value, currencyOptions)
  }
  return currency(toFinite(value), currencyOptions)
}

export const percentage = (value) => {
  return currency(currency(value, percentageOptions).value * 100, percentageOptions)
}

/*
 * Sum Number values using the currency object.
 */
export const sumCurrency = (values) => {
  const summedValue = reduce(values, (accumulator, value) =>
    R(accumulator).value + R(value).value
    , 0)
  return R(summedValue)
}

const randOptions = {
  symbol: 'R ',
  separator: ' ',
  precision: 0
}

const percentageOptions = {
  symbol: '%',
  pattern: '# !',
  precision: 2
}
